import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CTA_LABEL } from "@/config/site";

const BASE =
  "btn-press inline-flex items-center justify-center gap-2 rounded-2xl font-semibold text-sm sm:text-base px-7 py-4";

export const AuditCta = ({
  label = CTA_LABEL,
  to = "/audit",
  testId = "audit-cta",
  variant = "solid",
  withArrow = true,
  className = "",
}) => {
  const styles =
    variant === "onDark"
      ? "bg-[#C8703A] text-[#F4E9D8] hover:bg-[#B35F2C]"
      : variant === "outline"
      ? "border border-[#1F1F1C]/25 text-[#1F1F1C] hover:border-[#C8703A] hover:text-[#C8703A]"
      : "bg-[#C8703A] text-[#F4E9D8] hover:bg-[#B35F2C]";

  return (
    <Link to={to} className={`${BASE} ${styles} ${className}`} data-testid={testId}>
      {label}
      {withArrow && <ArrowRight className="w-4 h-4" strokeWidth={2.25} />}
    </Link>
  );
};

export default AuditCta;
